import { render } from "./AlartModal.vue?vue&type=template&id=fa4bc86e&scoped=true"
import script from "./AlartModal.vue?vue&type=script&lang=js"
export * from "./AlartModal.vue?vue&type=script&lang=js"

import "./AlartModal.vue?vue&type=style&index=0&id=fa4bc86e&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa4bc86e"]])

export default __exports__